import { Controller } from "@hotwired/stimulus"

// Builder-level controls for the Beat-Synced Short: master song upload/volume
// and scene reordering (up/down). Scene cards live inside this controller's
// element, so their reorder buttons (data-action="beat-synced-builder#moveUp")
// bubble up to here.
export default class extends Controller {
  static values = {
    songUploadUrl: String, songUpdateUrl: String, songRemoveUrl: String, reorderUrl: String
  }
  static targets = ["songInput", "sceneList"]

  pickSong() { this.songInputTarget.click() }

  async onSong(event) {
    const file = event.target.files && event.target.files[0]
    if (!file) return
    const body = new FormData()
    body.append("file", file)
    const res = await fetch(this.songUploadUrlValue, { method: "POST", headers: this.headers(), body })
    if (res.ok) window.location.reload()
    else alert("Song upload failed")
  }

  setSongVolume(event) {
    const volume = (parseInt(event.target.value, 10) || 0) / 100
    clearTimeout(this._t)
    this._t = setTimeout(() => {
      fetch(this.songUpdateUrlValue, {
        method: "PATCH",
        headers: { ...this.headers(), "Content-Type": "application/json" },
        body: JSON.stringify({ volume })
      })
    }, 250)
  }

  async removeSong() {
    if (!confirm("Remove the master song?")) return
    const res = await fetch(this.songRemoveUrlValue, { method: "DELETE", headers: this.headers() })
    if (res.ok) window.location.reload()
  }

  moveUp(event) { this.move(event, -1) }
  moveDown(event) { this.move(event, 1) }

  move(event, dir) {
    const card = event.target.closest("[data-scene-id]")
    if (!card) return
    const sibling = dir < 0 ? card.previousElementSibling : card.nextElementSibling
    if (!sibling) return
    if (dir < 0) card.parentNode.insertBefore(card, sibling)
    else card.parentNode.insertBefore(sibling, card)
    this.persistOrder()
  }

  persistOrder() {
    const order = Array.from(this.sceneListTarget.querySelectorAll("[data-scene-id]"))
      .map((el) => el.dataset.sceneId)
    fetch(this.reorderUrlValue, {
      method: "POST",
      headers: { ...this.headers(), "Content-Type": "application/json" },
      body: JSON.stringify({ order })
    }).then((res) => { if (!res.ok) window.location.reload() })
  }

  headers() {
    return { "X-CSRF-Token": document.querySelector('meta[name="csrf-token"]')?.content }
  }
}
